import {Section} from "./Section";
import {Order} from "../Order";

export class AddressSection extends Section {

  constructor(sectionElement) {
    super(sectionElement);

    this.previousSectionButton = this.element.querySelector('[data-button="prev"]');
    this.nextSectionButton = this.element.querySelector('[data-button="next"]');
    this.formElement = this.element.querySelector('form');
    this.defaultFormData = Object.fromEntries(new FormData(this.formElement));

    AddressSection.shippingInfos = this.shippingInfos;
    AddressSection.element = this.element;
    AddressSection.formElement = this.formElement;
  }

  static get formDataObject() {
    return Object.fromEntries(new FormData(AddressSection.formElement));
  }

  static updateFormFields() {
    const SHIPPING_DATA = Order.address;
    const FORM_ELEMENT = AddressSection.formElement;
    const FORM_FIELDS = FORM_ELEMENT.elements;

    const SHIPPING_ADDRESS_SECTION = FORM_ELEMENT.querySelector('[data-toggled-by="differ"]');
    const SHIPPING_ADDRESS_FORM_ELEMENTS = SHIPPING_ADDRESS_SECTION.querySelectorAll('[data-required="toggle"]');

    Section.updateFormFields(FORM_FIELDS, SHIPPING_DATA);

    for (const FORM_FIELD of FORM_FIELDS) {
      if (FORM_FIELD.getAttribute('data-toggle')) {
        if (FORM_FIELD.checked) {
          SHIPPING_ADDRESS_SECTION.classList.remove('d-none');
          SHIPPING_ADDRESS_FORM_ELEMENTS.forEach(formElement => formElement.setAttribute('required', 'true'));
        } else {
          SHIPPING_ADDRESS_SECTION.classList.add('d-none');
          SHIPPING_ADDRESS_FORM_ELEMENTS.forEach(formElement => {
            formElement.removeAttribute('required');
            formElement.value = '';
          });
        }
      }
    }
  }

  static validateFormFields() {
    const FORM_FIELDS = AddressSection.formElement.elements;
    const FORM_FIELDS_ARRAY = Array.from(FORM_FIELDS)
    const FORM_FIELDS_ARRAY_REVERSE = FORM_FIELDS_ARRAY.reverse();

    let isValid = true;

    FORM_FIELDS_ARRAY_REVERSE.forEach(formField => {
      if (!formField.checkValidity()) {
        formField.reportValidity();
        formField.scrollIntoView({behavior: 'smooth', block: 'start'});
        isValid = false;
      }
    });

    return isValid;
  }
}

export const INSTANTIATE_ADDRESS_SECTION = () => {
  const PAYMENT_SECTION_ELEMENT = document.querySelector('[data-section="address"]');
  if (!PAYMENT_SECTION_ELEMENT) return;

  return new AddressSection(PAYMENT_SECTION_ELEMENT);
}
